
import { Component, Inject, Prop, Vue } from "vue-property-decorator";
import { AnalyticFilter, Dict, ManufactureInternal } from "@gsx/common";
import VueApexCharts from "vue-apexcharts";
import { Container } from "inversify";
import { OrganizationListStore } from "../../stores/organization/OrganizationListStore";
import Loader from "../components/Loader.vue";
import { AnalyticFavoriteManager } from "../../utils/AnalyticFavoriteManager";
import FavoriteBtn from "../components/FavoriteBtn.vue";
import { AnalyticFiltering } from "./AnalyticFiltering";

@Component({ components: { Loader, VueApexCharts, FavoriteBtn } })
export default class InternalManufacturing extends Vue {
    @Prop() readonly chartHeight!: string;
    @Prop() readonly analyticFilter?: AnalyticFilter;
    @Inject("container") readonly container!: Container;
    organizationListStore: OrganizationListStore = this.container.get(OrganizationListStore);
    analyticFavoriteManager: AnalyticFavoriteManager = this.container.get(AnalyticFavoriteManager);
    analyticFiltering: AnalyticFiltering = this.container.get(AnalyticFiltering);

    get isFavorite() {
        // @ts-ignore
        return this.analyticFavoriteManager.isFavorite(this.$options._componentTag);
    }

    async toggleFavorite() {
        // @ts-ignore
        await this.analyticFavoriteManager.toggleFavorite(this.$options._componentTag);
    }

    get internalManufacuringCountriesChart() {
        let items = [];
        if (this.analyticFilter) {
            items = this.analyticFiltering.filteredItems(this.analyticFilter);
        } else {
            items = this.organizationListStore.filteredItems;
        }

        const countries = items
            .filter(
                (organization) =>
                    organization.manufactureInternal &&
                    organization.manufactureInternal.includes(
                        ManufactureInternal.InternalManufacture,
                    ) &&
                    organization.country,
            )
            .map((organization) => organization.country!)
            .reduce((prev: Dict, curr: string) => {
                prev[curr] = prev[curr] ? prev[curr] + 1 : 1;
                return prev;
            }, {});

        // https://apexcharts.com/react-chart-demos/column-charts/column-with-data-labels/
        return {
            chartOptions: {
                labels: Object.keys(countries).sort((a, b) => countries[b] - countries[a]),
                plotOptions: {
                    bar: {
                        dataLabels: {
                            position: "top",
                        },
                    },
                },
                dataLabels: {
                    enabled: true,
                    offsetY: -20,
                    style: {
                        colors: ["#304758"],
                    },
                },
            },
            series: [
                {
                    name: "Internal Manufacturing",
                    data: Object.values(countries).sort((a, b) => b - a),
                },
            ],
        };
    }
}
